// extracted by mini-css-extract-plugin
export default {"container":"SkillsList_container__DuDl1","heading":"SkillsList_heading__oVGOA","skillList":"SkillsList_skillList__02WBe"};